export default __webpack_public_path__ + "static/media/Gulmarg2.b4dedfa0.jpg";